import LocationCardTabs from 'modules/locations/components/LocationCardTabs';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LocationsPage() {
  const { t } = useTranslation('locations.LocationsPage');

  return (
    <ProfileSideMenuWrapper title={t('pageTitle')}>
      <LocationCardTabs />
    </ProfileSideMenuWrapper>
  );
}
